import http from './http'
class WordDensity {
    static startSingle(params) {
        return http.httpPost('keywordDensity/startSingle', params);
    }
    static progress(params) {
        return http.httpPost('keywordDensity/progress', params);
    }
    static getFilterList(params) {
        return http.httpPost('keywordDensity/getFilterList', params);
    }
    static downloadReport(params) {
        return http.getBaseUrl() + '/keywordDensity/downloadReport?token=' + params.token;
    }



}
export default WordDensity;



// WEBPACK FOOTER //
// ./app/api/word.density.api.js